import { render, staticRenderFns } from "./MoreTabItem.vue?vue&type=template&id=b984c5d0&"
import script from "./MoreTabItem.vue?vue&type=script&lang=js&"
export * from "./MoreTabItem.vue?vue&type=script&lang=js&"
import style0 from "./MoreTabItem.vue?vue&type=style&index=0&lang=postcss&module=css&"




function injectStyles (context) {
  
  this["css"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports